module.exports = __webpack_public_path__ + "static/scale-model-of-buechel-train-depot-in-louisville-kentucky-9fd888c622f6ab0ea9ea4afc7bbc139c.png";